// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3Kv1K","dragIcon":"Choice_dragIcon__3tQ5o","left":"Choice_left__RkWjh","input":"Choice_input__17ZSx"};